import { BaseButton, Popover, PopoverItem, Variables } from '@enter/core';
import styled from '@emotion/styled';
import { mdiDotsVertical } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';

const FabContainer = styled.div`
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 1;
`;

const FabPopover = styled(Popover)`
    display: inline-flex;
`;

// A plain header row above the menu actions. `Popover` clones every direct child with
// `closeMenu`/`pinned`/`selectable`/`openSubmenu`/`closeSubmenu` (see base `Popover.renderChildren`);
// declaring — and swallowing — those props here keeps them from landing on the underlying `<div>` as
// unrecognized DOM attributes.
const FabMenuLabel: React.FC<{
    children?: React.ReactNode;
    closeMenu?: () => void;
    pinned?: boolean;
    selectable?: boolean;
}> = ({ children }) => <FabMenuLabelStyled>{children}</FabMenuLabelStyled>;

const FabMenuLabelStyled = styled.div`
    padding: 8px 16px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMedium};
    white-space: nowrap;
`;

export const ClaimListBatchActionsToolbar: React.FC<{
    selectedCount: number;
    onCloseout: () => void;
    onSuppressCoderRules: () => void;
    onRestoreCoderRules: () => void;
    disabled?: boolean;
}> = ({ selectedCount, onCloseout, onSuppressCoderRules, onRestoreCoderRules, disabled }) => {
    if (selectedCount === 0) {
        return null;
    }

    return (
        <FabContainer>
            <FabPopover
                align="right"
                verticalAlign="top"
                renderButton={() => (
                    <BaseButton variant="fab-light" size="large" disabled={disabled}>
                        <Icon path={mdiDotsVertical} size={1} />
                    </BaseButton>
                )}
            >
                <FabMenuLabel>
                    {selectedCount} claim{selectedCount === 1 ? '' : 's'} selected
                </FabMenuLabel>
                <PopoverItem onClick={onCloseout} disabled={disabled}>
                    Close out claims
                </PopoverItem>
                <PopoverItem onClick={onRestoreCoderRules} disabled={disabled}>
                    Restore coder rules
                </PopoverItem>
                <PopoverItem onClick={onSuppressCoderRules} disabled={disabled}>
                    Suppress coder rules
                </PopoverItem>
            </FabPopover>
        </FabContainer>
    );
};
